import { render, staticRenderFns } from "./ViPricing.vue?vue&type=template&id=ded1d172&scoped=true"
import script from "./ViPricing.vue?vue&type=script&lang=js"
export * from "./ViPricing.vue?vue&type=script&lang=js"
import style0 from "./ViPricing.vue?vue&type=style&index=0&id=ded1d172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded1d172",
  null
  
)

export default component.exports